import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import itemId from 'owa-service/lib/factory/itemId';
import { getGuid } from 'owa-guid';

export function prepareSeriesItemsForInstantUpdate(items: CalendarEvent[]) {
    let clientSeriesId = getGuid();
    items.forEach(item => {
        // We can't have the same ItemId for instances of a recurring meeting as it's the primary key for the cache,
        // but the InstanceKey will be set to clientSeriesId for isNewCalendarItem check for local lie.
        prepareItemForInstantUpdateInternal(item, clientSeriesId);
        item.IsRecurring = true;
        item.InstanceKey = item.InstanceKey ? item.InstanceKey : clientSeriesId;
    });
}

export function prepareItemForInstantUpdate(
    item: CalendarEvent,
    clientSeriesId: string = getGuid()
) {
    // We want to make the ItemId match the ClientSeriesId for non-recurring meetings
    prepareItemForInstantUpdateInternal(item, clientSeriesId, clientSeriesId);
}

function prepareItemForInstantUpdateInternal(
    item: CalendarEvent,
    clientSeriesId: string = getGuid(),
    temporaryItemId: string = getGuid()
) {
    item.ItemId = {
        ...itemId({ Id: temporaryItemId }),
        mailboxInfo: item.ParentFolderId.mailboxInfo,
    };
    if (!item.ClientSeriesId) {
        // If we have the ClientSeriesId already set, then it means this is the retry scenario
        // In the retry scenario, we don't override the clientSeriesId since we want the server to be
        // able to de-duplicate in case the failed request created the item for some reason
        item.ClientSeriesId = clientSeriesId;
    }

    item.EffectiveRights = {
        Read: true,
        Modify: true,
        Delete: true,
        ViewPrivateItems: true,
    };
    item.IsOrganizer = true;
}
